//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      pageData: this.page
    };
  },

  watch: {
    page: {
      handler(newVal, oldVal) {
        this.pageData = newVal;
      },
      immediate: false
    }
  },

  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    },
    allPage: {
      type: Number,
      default: 233
    },
    maxPage: {
      type: Number,
      default: 10
    }
  },

  methods: {
    changePage(value) {
      value = parseInt(value);
      if (typeof value === "number" && value <= this.allPage && value >= 1) {
        this.$emit("change-page", value);
      } else {
        this.$vux.toast.text("跳转的页码超出限制", "middle");
        throw TypeError("pageValue is not a lawful number");
      }
    },
    nextPage() {
      if (this.page >= this.maxPage) {
        if (
          window.location.hostname.includes("m.xczim.com") ||
          window.location.hostname.includes("lib.xcz.im")
        ) {
          this.$vux.confirm.show({
            title: "提示",
            content: "请前往 App 查看更多内容",
            confirmText: "前往",
            onConfirm: () => {
              window.open(
                "https://a.app.qq.com/o/simple.jsp?pkgname=com.hustzp.com.xichuangzhu",
                "_blank"
              );
            }
          });
        } else {
          this.$vux.toast.text("已经是最后一页了哦", "middle");
        }
        return;
      }

      if (this.page < this.allPage) {
        this.$emit("change-page", this.page + 1);
      } else {
        this.$vux.toast.text("已经是最后一页了哦", "middle");
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.$emit("change-page", this.page - 1);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/nav_common/CommonPages.vue